import { useEffect } from 'react'

export const LongTaskMonitor = ({
  threshold = 20000,
}: {
  threshold?: number
}) => {
  useEffect(() => {
    if (typeof PerformanceObserver === 'undefined' || !window.newrelic) {
      console.warn(
        'Performance monitoring is disabled: ' +
          `${typeof PerformanceObserver === 'undefined' ? 'PerformanceObserver is not supported. ' : ''}` +
          `${!window.newrelic ? 'New Relic is not available.' : ''}`
      )
      return
    }

    const observer = new PerformanceObserver(list => {
      for (const entry of list.getEntries()) {
        if (entry.duration >= threshold) {
          const message = `Long task detected`
          console.warn(message, {
            duration: entry.duration,
            name: entry.name,
            startTime: entry.startTime,
          })

          window.newrelic.noticeError(new Error(message), {
            duration: entry.duration,
            name: entry.name,
            startTime: entry.startTime,
          })
        }
      }
    })

    try {
      observer.observe({ entryTypes: ['longtask'] })
    } catch (err) {
      console.error('Failed to observe longtasks', err)
    }

    return () => observer.disconnect()
  }, [threshold])

  return null
}
